<template>
    <div class="my-6">
        <button
            class="
                bg-primary
                rounded-lg
                py-2
                px-3
                text-white text-xs
                flex
                items-center
                gap-2
            "
            @click="state.isCreateMode = true"
            v-if="!state.isCreateMode && !state.isEditMode"
        >
            <ion-icon name="add-outline"></ion-icon>
            Add New Formation
        </button>
        <div v-if="state.isCreateMode" class="flex gap-2 items-center w-full">
            <input
                v-model="state.formationName"
                class="bg-gray-100 rounded-lg py-2 px-3 text-xs w-full"
                placeholder="Formation Name"
            />

            <button
                class="
                    bg-primary
                    rounded-lg
                    py-2
                    px-3
                    text-white text-xs
                    flex
                    items-center
                    gap-1
                "
                @click="create"
            >
                <ion-icon name="save-outline"></ion-icon>
                Save
            </button>
            <button
                class="
                    bg-gray-400
                    rounded-lg
                    py-2
                    px-3
                    text-white text-xs
                    flex
                    items-center
                    gap-1
                "
                @click="state.isCreateMode = false"
            >
                <ion-icon name="close-outline"></ion-icon>
                Cancel
            </button>
        </div>
        <table class="mt-6" v-if="state.formations.length">
            <tbody>
                <tr
                    v-for="formation in state.formations"
                    :key="formation.id"
                    class="border-b border-gray-200"
                >
                    <td class="text-left text-sm p-2 w-[100%]">
                        <span v-if="state.isEditMode !== formation.id">
                            {{ formation.name }}
                        </span>
                        <div v-else class="flex gap-2">
                            <input
                                v-model="state.formationName"
                                class="
                                    bg-gray-100
                                    rounded-lg
                                    py-2
                                    px-3
                                    text-xs
                                    w-full
                                "
                                placeholder="Formation Name"
                            />

                            <button
                                class="
                                    bg-primary
                                    rounded-lg
                                    py-2
                                    px-3
                                    text-white text-xs
                                    flex
                                    items-center
                                    gap-1
                                "
                                @click="update(formation)"
                            >
                                <ion-icon name="save-outline"></ion-icon>
                                Save
                            </button>
                            <button
                                class="
                                    bg-gray-400
                                    rounded-lg
                                    py-2
                                    px-3
                                    text-white text-xs
                                    flex
                                    items-center
                                    gap-1
                                "
                                @click="state.isEditMode = null"
                            >
                                <ion-icon name="close-outline"></ion-icon>
                                Cancel
                            </button>
                        </div>
                    </td>
                    <td class="text-left">
                        <a
                            class="text-primary text-sm cursor-pointer"
                            @click="edit(formation)"
                            >Edit</a
                        >
                    </td>
                    <td class="text-left">
                        <a
                            class="text-red-500 text-sm ml-2 cursor-pointer"
                            @click="destroy(formation)"
                            >Delete</a
                        >
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script setup>
import { defineProps, reactive, onMounted } from "vue";
import emitter from "tiny-emitter/instance";

const props = defineProps({
    teamId: {
        type: Number,
    },
});

const state = reactive({
    formations: [],
    formationName: "",
    isCreateMode: false,
    isEditMode: null,
});

async function notifyUpdated() {
    const data = await getData();
    emitter.emit("formation-updated", data);
}

async function getData() {
    const teamId = props.teamId ? props.teamId : "";
    state.formations = (await axios.get(`/formation?teamId=${teamId}`)).data;
    return state.formations;
}

function edit(formation) {
    state.isEditMode = formation.id;
    state.formationName = formation.name;
}

async function create() {
    await axios.post("/formation", {
        name: state.formationName,
        teamId: props.teamId,
    });
    state.formationName = "";
    state.isCreateMode = false;
    notifyUpdated();
}
async function update(formation) {
    await axios.post(`/formation/${formation.id}/update`, {
        name: state.formationName,
    });
    state.formationName = "";
    state.isEditMode = null;
    notifyUpdated();
}

async function destroy(formation) {
    await axios.post(`/formation/${formation.id}/delete`);
    notifyUpdated();
}

onMounted(() => {
    getData();
});
</script>
